/**
 * Get search parameters from a string.
 * Values are not converted, they are always strings.
 * Keys that exist but have no value, such as `&debug&`, have their values set to `"true"`.
 * @param search Source string
 */
export const getParameters = (search: string): {[key: string]: string} =>
{
    if (search === "")
    {
        return {};
    }

    const hashes = search.slice(search.indexOf("?") + 1)
        .split("&");

    return hashes.reduce(
        (params: {}, hash): {[key: string]: string} =>
        {
            const split = hash.indexOf("=");

            if (split < 0) {
                return {
                    ...params,
                    [hash]: "true",
                };
            }

            const key = hash.slice(0, split);
            const val = hash.slice(split + 1);

            return {...params,  [key]: decodeURIComponent(val)};
        },
        {},
    );
};

const parameters = getParameters(window.location.search);

/**
 * Get a window query parameter value.
 * Returns the string `"true"` if the parameter is present but has no value, e.g. `?view=1&iamtrue&something=else`
 * Returns undefined if the parameter is not present.
 * @param key Name of the key
 */
export const getWindowParameter = (key: string): string | undefined =>
    parameters[key];

/**
 * Returns true if a parameter exists
 * @param key Name of the key
 */
export const hasWindowParameter = (key: string): boolean =>
    Object.prototype.hasOwnProperty.call(parameters, key);
